var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _g, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTableIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H63.6667L67.5 4L72 8.5V64H22V0Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H63.6667V8.5H72V64H22V0Z",
    fill: "#475569"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 38,
    height: 4,
    fill: "#334155"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 38,
    height: 4,
    fill: "#334155"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 38,
    height: 4,
    fill: "#334155"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 38,
    height: 4,
    fill: "#334155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0619 36.5979L18.9753 39.6528L5.68834 54.0105C4.58575 55.202 2.70656 55.2161 1.58622 54.0413L0.865454 53.2855C-0.254883 52.1108 -0.151733 50.2343 1.09062 49.1895L16.0619 36.5979Z",
    fill: "#FEAD05"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3920_76779",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 36,
    width: 19,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0619 36.5979L18.9753 39.6528L5.68834 54.0105C4.58575 55.202 2.70656 55.2161 1.58622 54.0413L0.865454 53.2855C-0.254883 52.1108 -0.151733 50.2343 1.09062 49.1895L16.0619 36.5979Z",
    fill: "#FEAD05"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3920_76779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3897 45.0166C14.4573 44.3266 13.5712 43.5474 12.7433 42.6793C11.9154 41.8112 11.1791 40.8892 10.5341 39.9252L14.8302 36.312C15.374 37.2037 16.0209 38.0514 16.7711 38.8381C17.5214 39.6248 18.3374 40.3111 19.2024 40.8966L15.3897 45.0166Z",
    fill: "#FC680A"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 27.6406,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 27.6406 10)",
    fill: "#755734",
    style: {
      mixBlendMode: "color"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6406,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 27.6406 10)",
    stroke: "#FEAD05",
    strokeWidth: 4.2214
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableIllustration);
export default __webpack_public_path__ + "static/media/empty_table_illustration.cad5d07445e978ad95536380421716f9.svg";
export { ForwardRef as ReactComponent };